import React from 'react';
import { HeadingText } from '@paypalcorp/pp-react';

// Containers
import SearchBox from '../containers/SearchBox';

// Components
import HeroLink from './HeroLink';

// Helper
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import l10n from '../../lib/reactPPl10nHelper';
import { trackLink } from '../../lib/analytics-helper';
import {
  getC3MarketChannelEligibility,
  isNewPrivacyPageEnabled,
  isWebFormWithoutTCodeEnabled,
} from '../../lib/globalHelper';
import { contactChannels, topicNames } from '../../common/commonConstants';
import { getLastPathVariable } from '../../lib/location-helper';
import { elmoTreatmentNames, isPartOfElmoExpTreatment } from '../../lib/experiments-helper';

const links = {
  community: Page.getCommunityLink(),
  resolutionCenter: Page.getResolutionURL(),
  smartHelpHome: Page.getHomeURL(),
  smcurl: '/smc/customer',
};

const labels = {
  communitySmallScreen: i18n.message('smarthelp/heroSection.heroLinks.community.smallScreen'),
  communityLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.hcr.community.largeScreen'),

  resolutionSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.smallScreen'),
  resolutionLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.largeScreen'),

  emailSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.email.smallScreen'),
  emailLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.email.largeScreen'),
  header: l10n.getContent('smarthelp/channelSelection.contactUs.header'),
  privacyPageHeader: l10n.getContent('smarthelp/emailUs.emailUs.pageHeader'),
  aupViolationPageHeader: l10n.getContent('smarthelp/paypalmeForm.paypalform.pageHeading'),
};

const HelpHeading = i18n.message('smarthelp/heroSection.heroLinks.helpcenter.largeScreen');

let FPTIId = '';

const HeroSectionNoLink = () => {
  const FptiTracking = (fptiStr) => {
    FPTIId = Page.getFPTIPageId();
    trackLink({ id: FPTIId, link: `smarthelp-hero-links|${fptiStr}` });
  };

  const renderCommunity = () => {
    // checking if market enabled in c3merchantMigration RC or user is c2merchantmigrated and
    // channel existance in the c3merchantMigration RC
    if (links.community && getC3MarketChannelEligibility(contactChannels.COMMUNITY)) {
      return (
        <HeroLink
          type="community"
          link={links.community}
          message={{
            full: labels.communityLargeScreen,
            short: labels.communitySmallScreen,
          }}
          clickHandler={FptiTracking}
        />
      );
    }
    return null;
  };

  const renderResolutionCenter = () => {
    // checking if market enabled in c3merchantMigration RC or user is c2merchantmigrated and
    // channel existance in the c3merchantMigration RC
    if (links.resolutionCenter && getC3MarketChannelEligibility(contactChannels.RESOLUTION)) {
      return (
        <HeroLink
          type="resolution"
          link={links.resolutionCenter}
          message={{
            full: labels.resolutionLargeScreen,
            short: labels.resolutionSmallScreen,
          }}
          clickHandler={FptiTracking}
        />
      );
    }
    return null;
  };
  const renderMessageCenter = () => {
    const treatmentsAvailable = Page.elmoTreatments();
    const isPartOfMCLinkTreatment = isPartOfElmoExpTreatment(
      treatmentsAvailable,
      elmoTreatmentNames.messageCenterLinkShowExp,
    );
    // checking if market enabled in c3merchantMigration RC or user is c2merchantmigrated and
    // channel existance in the c3merchantMigration RC
    // Do not display the message center link if the user is part of this message center link treatment
    if (
      Page.getIsSmcEnabled() &&
      getC3MarketChannelEligibility(contactChannels.MESSAGE_CENTER) &&
      !isPartOfMCLinkTreatment
    ) {
      return (
        <HeroLink
          type="message"
          link={links.smcurl}
          message={{
            full: labels.emailLargeScreen,
            short: labels.emailSmallScreen,
          }}
          clickHandler={FptiTracking}
        />
      );
    }
    return null;
  };

  const renderSearch = () => {
    const queryValue = getLastPathVariable(window.location);

    let pageHeader = '';
    // Changing the page header for new privacy page
    if (queryValue === topicNames.PRIVACY && isNewPrivacyPageEnabled()) {
      pageHeader = <h1 className="hero-search-header-replacement privacy-page-header">{labels.privacyPageHeader}</h1>;
    } else if (queryValue === topicNames.AUP_VIOLATION) {
      pageHeader = (
        <HeadingText size="lg" className="hero-search-header-replacement aup-violation-page-header">
          {labels.aupViolationPageHeader}
        </HeadingText>
      );
    } else if (isWebFormWithoutTCodeEnabled()) {
      const webformPageHeader = i18n.message('smarthelp/complaints.complaintsPage.webformPageHeader');
      pageHeader = (
        <HeadingText size="lg" className="hero-search-header-replacement webform-complaints-page-header">
          {webformPageHeader}
        </HeadingText>
      );
    } else {
      pageHeader = Page.isSearchTopicDisplay() ? (
        <h1 className="hero-search-header-replacement">{labels.header}</h1>
      ) : (
        <SearchBox FPTIId={FPTIId} />
      );
    }

    return <div className="search-box-container">{pageHeader}</div>;
  };

  const renderHeroModule = () => {
    FPTIId = Page.getFPTIPageId();
    return (
      <div className="hero-selection-hcr">
        <div className="hero-selection-hcr-content">
          <div className="hero-selection-home-link">
            <a href={links.smartHelpHome} className="hero-selection-heading">
              {HelpHeading}
            </a>
          </div>
          {renderSearch()}
          <div className="hero-selection-placeholder">
            <div className="hero-links">
              {renderCommunity()}
              {renderResolutionCenter()}
              {renderMessageCenter()}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return renderHeroModule();
};

export default HeroSectionNoLink;
